let baseUrl = 'https://admin.shahehongfa.com/'
// let baseUrl = 'http://local.dh.com/'  //这个是原来用的
// let baseUrl = 'http://local.dhbuild.com/' //这个用正式的了本地测试域名
let business = baseUrl + 'member'; //会员中心--店铺名称/电话
let passEdit = baseUrl + 'passEdit';//修改密码
let registered = baseUrl + 'registered';//注册用户
let login = baseUrl + 'login';//登陆
let advertisement = baseUrl + 'advertisement';//广告列表
let shopList = baseUrl + 'shopList';//商品列表
let shopListSearch = baseUrl + 'shopListSearch';//商品搜索列表
let ShopAdd = baseUrl + 'ShopAdd';//购物车新增和更改
let ShoppingCart = baseUrl + 'ShoppingCart';//购物车列表
let ShopDel = baseUrl + 'ShopDel';//购物车删除
let orderDetails = baseUrl + 'orderDetails';//提交订单 页面
let order = baseUrl + 'order';//提交确认订单
let waitingOrder = baseUrl + 'waitingOrder';//待接单 已接单 页面
let OrdersDetails = baseUrl + 'OrdersDetails';//待接单 已接单 详情 页面
let address = baseUrl + 'address';//地址列表
let addressSave = baseUrl + 'addressSave';//新增地址 修改地址 页面
let del = baseUrl + 'del';//删除地址 页面
let count = baseUrl + 'count';//计算购物车总数量和总结order
let type = baseUrl + 'type'; //分类列表请求
let checktoken = baseUrl + 'checktoken'; //分类列表请求
export default {
    business,
    order,
    type,
    passEdit,
    address,
    registered,
    login,
    shopList,
    shopListSearch,
    ShopAdd,
    ShoppingCart,
    ShopDel ,
    orderDetails,
    waitingOrder,
    OrdersDetails,
    address,
    del,
    count,
    addressSave,
    advertisement,
    checktoken
}



// WEBPACK FOOTER //
// ./src/lmj_Api/api.js